export default __webpack_public_path__ + "static/media/undereyePuffiness.fd030836.svg";